function normalizeOrigin(value) {
  if (!value) return ''
  try {
    const url = new URL(value, window.location.origin)
    if (!['http:', 'https:'].includes(url.protocol)) return ''
    return url.origin
  } catch {
    return ''
  }
}

export function getPublicSiteOrigin() {
  return normalizeOrigin(import.meta.env.VITE_PUBLIC_SITE_URL) || window.location.origin
}

export function getDownloadShareUrl() {
  return `${getPublicSiteOrigin()}/download`
}
